import {ReactNode} from 'react';

import {css, view} from '@sail/ui';

import {Wave} from '@stripe-internal/conversations-ui';

const paneStyles = [
  css({
    position: 'relative',
    flexGrow: '1',
    stack: 'y',
    overflow: 'hidden',
  }),
];

function Pane({children}: {children: ReactNode}) {
  return (
    <view.div data-testid="conversations-widget-pane" uses={paneStyles}>
      {children}
    </view.div>
  );
}

type Props = {
  header?: ReactNode;
  children?: ReactNode;
};

export function AssistantContainer({header, children}: Props) {
  return (
    <view.div
      data-testid="conversations-widget-root"
      onMouseEnter={() => {
        // TODO: this is a work around for the Tooltip to show up immediately
        // It helps the modality as "pointer" (as oppose to "keyboard"), and tooltip is only shown if the user is using pointer
        document.dispatchEvent(new MouseEvent('pointerdown'));
        document.dispatchEvent(new MouseEvent('mousedown'));
      }}
      css={{
        overflow: 'hidden',
        position: 'relative',
        stack: 'y',
        height: 'fill',
        backgroundColor: 'white',
      }}
    >
      {header}
      <view.div
        css={{
          height: 'fill',
          overflow: 'clip',
          position: 'relative',
          stack: 'y',
          ':before': {
            content: '""',
            position: 'absolute',
            top: '-80px',
            left: 'space.0',
            right: 'space.0',
            height: '430px',
            width: 'fill',
            backgroundSize: 'cover',
          },
        }}
      >
        <Wave
          css={{
            position: 'absolute',
            width: 'fill',
            top: '0px',
          }}
          focused={false}
          loading={false}
        />
        <Pane>{children}</Pane>
      </view.div>
    </view.div>
  );
}
